export class ServiceLevelTransformer {
  static transform (obj) {
    let serviceLevel = {}

    serviceLevel.id = obj.id
    serviceLevel.priority = obj.attributes.priority
    serviceLevel.hoursToStart = obj.attributes.hours_to_start
    serviceLevel.hoursToFinish = obj.attributes.hours_to_finish
    serviceLevel.density = obj.attributes.density
    serviceLevel.status = obj.attributes.status
    serviceLevel.archivedAt = obj.attributes.archived_at

    return serviceLevel
  }
}



// WEBPACK FOOTER //
// ./src/helpers/serviceLevels/serviceLevel.transformer.js